import { actionTypes, mutationTypes } from '@/types';
import { getValueLanguageConent } from '@/tools/languageValue';
import { setUrlToDataSource } from '@/tools/setUrlToDataSource';
import { uiComponents, uiStates } from '@/tools/viewState';

export default {
	state: {
		backgroundImageURL: null,
		gameData: null,
		words: null,
		secretWord: null,
		secretWordMetaData: null,
		bubbleOneText: null,
		bubbleTwoText: null,
	},
	mutations: {
		[mutationTypes.setGameData](state, { gameData }) {
			state.gameData = gameData;
		},
		[mutationTypes.setBackgroundImageURL](state, { backgroungImageURL }) {
			state.backgroundImageURL = backgroungImageURL;
		},
		[mutationTypes.setWords](state, { words }) {
			state.words = words;
		},
		[mutationTypes.secretWord](state, { word }) {
			state.secretWord = word;
		},
		[mutationTypes.secretWordMetaData](state, { metaData }) {
			state.secretWordMetaData = metaData;
		},
		[mutationTypes.bubbleOneText](state, { bubbleOneText }) {
			state.bubbleOneText = bubbleOneText;
		},
		[mutationTypes.bubbleTwoText](state, { bubbleTwoText }) {
			state.bubbleTwoText = bubbleTwoText;
		},
		[mutationTypes.restartHangmanGame](state) {
			state.secretWord = null;
			state.secretWordMetaData = null;
		},
	},
	actions: {
		[actionTypes.startHangmanGame]({ commit, getters, rootState }) {
			let languageContent = null;
			commit(mutationTypes.viewStateSetUiState, [
				{ id: uiComponents.uiHangManGame, uiState: uiStates.maximised },
			]);
			if (rootState.gameMode === 'kids') {
				languageContent = getters.getArticleByType('hangmanGame');
			} else {
				languageContent = getters.getArticleByArticleTags('abcBubbleGameInfoForAdults');
			}
			// setting bubble data
			const [lc] = languageContent.languageContent.filter((lc) => lc.languageISO === getters.currentLanguage);
			const bubbleOneInfo = lc.title.split('|');
			const bubbleTwoInfo = lc.description.split('|');
			commit(mutationTypes.bubbleOneText, {
				bubbleOneText: bubbleOneInfo,
			});
			commit(mutationTypes.bubbleTwoText, {
				bubbleTwoText: bubbleTwoInfo,
			});
		},
		[actionTypes.loadGameData]({ commit }, { gameData }) {
			commit(mutationTypes.setGameData, { gameData });
		},
		[actionTypes.setBackgroundImageForGame]({ rootState, commit, getters }, { article }) {
			if (article && article.coverID) {
				const currentLanguage = getters.currentLanguage;
				const languageContent = article.coverID.languageContent.filter(
					(lc) => lc.languageISO === currentLanguage
				);
				const backgroungImageURL = setUrlToDataSource(
					`../media-${getValueLanguageConent(languageContent, 'source')}/2048`,
					rootState.dataSourceURL
				);
				commit(mutationTypes.setBackgroundImageURL, { backgroungImageURL });
			}
		},
		[actionTypes.generateSecretWord]({ state, commit }) {
			if (state.gameData) {
				// remove this hardcode Stuff
				// need to do filter based on language
				const sheet = state.gameData.Sheet1;
				const words = sheet.map((data) => data.word);
				commit(mutationTypes.setWords, { words });
				const randomIndex = Math.floor(Math.random() * words.length);
				let word = words[randomIndex];
				let wordToCompare = word;
				word = word.replace(/\s+/g, '').toLowerCase();
				commit(mutationTypes.secretWord, { word });
				const [metaData] = sheet.filter((list) => list.word === wordToCompare);
				commit(mutationTypes.secretWordMetaData, { metaData });
			}
		},
		[actionTypes.restartHangmanGame]({ commit }) {
			commit(mutationTypes.restartHangmanGame);
		},
	},
};
